import { Link } from "react-router-dom";

import { getText } from '../../services/localization';

import styles from './OurServices.module.css';

export const OurServices = () => {
  return (
    <div className={styles.ourServices}>
      <div className="container">
        <h1>{getText('منتجاتنا', 'WAHT WE DO?')}</h1>
        <div className={styles.ourServicesWrapper}>
          <div className={styles.serviceCard}>
            <div className={styles.cardImage} style={{backgroundImage: 'url(https://storage.googleapis.com/door-assets/site/security/IMG-1412.jpg)'}}></div>
            <Link to="/product?type=security">{getText('أبواب', 'Doors')}</Link>
          </div>
          <div className={styles.serviceCard}>
            <div className={styles.cardImage} style={{backgroundImage: 'url("https://storage.googleapis.com/door-assets/site/steel_work/IMG_5595.jpg")'}}></div>
            <Link to="/product?type=steel_work">{getText('اعمال حديد', 'Steel Work')}</Link>
          </div>
          <div className={styles.serviceCard}>
            <div className={styles.cardImage} style={{backgroundImage: 'url(https://storage.googleapis.com/door-assets/site/kitchens/IMG_7156_web.jpg)'}}></div>
            <Link to="/product?type=kitchens">{getText('مطابخ', 'Kitchens')}</Link>
          </div>
          <div className={styles.serviceCard}>
            <div className={styles.cardImage} style={{backgroundImage: 'url("https://storage.googleapis.com/door-assets/site/bedrooms/IMG_1249.jpg")'}}></div>
            <Link to="/product?type=bedrooms">{getText('غرف نوم', 'Bedrooms')}</Link>
          </div>
        </div>
      </div>
    </div>
  )
}
